import type { studio as en } from "../en/studio";
import type { Messages } from "../types";

export const studio: Messages<typeof en> = {
  title: "استوديو الذكاء",
  description: "نصوص بصوت علامتك، صور لحسابك، وتقييم لكل منشور قبل نشره.",
  tabs: { captions: "النصوص", images: "الصور", scorer: "تقييم المنشور", history: "السجل" },
  captions: {
    title: "مولّد النصوص",
    hint: "صف المنشور واحصل على ثلاثة خيارات بأسلوبك ولغتك.",
    empty: "ستظهر النصوص هنا",
    emptyHint: "اكتب وصفاً قصيراً واختر الأسلوب.",
    copy: "نسخ",
    copied: "تم نسخ النص",
    usePost: "استخدمه في منشور",
    option: "الخيار {{n}}",
  },
  images: {
    title: "توليد الصور",
    prompt: "صف الصورة",
    promptPlaceholder: "لوحة تجريدية بالأزرق والسماوي، إضاءة ناعمة، قماش بملمس واضح، على جدار معرض",
    size: "المقاس",
    sizes: { square: "مربع", portrait: "طولي", landscape: "عرضي" },
    generate: "ولّد الصورة",
    generating: "جارٍ الرسم…",
    gallery: "مكتبة الوسائط",
    galleryHint: "تُحفظ الصور المولّدة في مكتبة الوسائط.",
    empty: "لا صور بعد",
    emptyHint: "ولّد صورتك الأولى وستُحفظ هنا.",
    usePost: "استخدمها في منشور",
    open: "فتح الصورة",
    saved: "حُفظت في مكتبة الوسائط",
    failed: "تعذّر توليد الصورة",
    ideas: "جرّب",
    idea1: "جدار معرض بسيط عليه ثلاث لوحات تجريدية مؤطرة",
    idea2: "لقطة قريبة لضربات فرشاة بالأكريليك الأزرق",
    idea3: "غرفة معيشة دافئة فيها لوحة زرقاء كبيرة فوق الكنبة",
    running: "يجري التوليد في الخلفية: يمكنك مغادرة هذه الصفحة وسننبّهك عند الجاهزية.",
    failedTitle: "لم تُولَّد الصورة",
    retry: "إعادة المحاولة",
    result: "الصورة المولّدة",
  },
  job: {
    running: "نعمل عليه في الخلفية…",
    failed: "لم ينجح ذلك",
    retry: "إعادة المحاولة",
  },
  history: {
    title: "ما ولّدته",
    hint: "كل توليد بالذكاء الاصطناعي يعمل كمهمة: أعد محاولة ما فشل، وأعد استخدام النتائج.",
    empty: "لا توجد عمليات توليد بعد",
    emptyHint: "تظهر هنا الصور والنصوص والتقييمات التي تولّدها.",
    all: "الكل",
    kinds: { ai_image: "الصور", ai_image_edit: "التعديلات", ai_caption: "النصوص", ai_occasion: "مسودات التقويم", ai_score: "التقييمات", ai_rule: "القواعد", ai_tts: "الصوت", ai_stt: "التفريغ النصي" },
    retry: "إعادة المحاولة",
    use: "استخدام",
    view: "عرض",
    delete: "حذف",
    deleted: "أزيل من السجل",
    deleteConfirm: "إزالة هذا التوليد من السجل؟ تبقى صوره في مكتبة الوسائط.",
    size: "المقاس {{size}}",
    noPrompt: "بدون وصف",
    filter: "تصفية حسب النوع",
  },
  scorer: {
    title: "تقييم المنشور",
    hint: "الصق النص لترى ما ينجح وما يحتاج إصلاحاً قبل النشر.",
    type: "نوع المنشور",
    placeholder: "الصق النص أو اكتبه…",
    usePost: "افتحه في المحرر",
  },
};
